import appData from '@/helpers/app-data'

const heatmapData = appData.get('heatmap') || {}

const state = {
  mapBounds: null,
  mapBoundsChangedByUser: false, // indicates the bounds got changed by the user directly interacting with the map
  mapInited: false,
  selectedHeatmapId: undefined,
  heatmapState: undefined, // 'LOADED', 'LOADING' or 'FAILED'

  // geo fields: {slug, id, name, type, geo_bounds, is_available?}
  // geo_bounds is the bounding box of the geo
  // the geo selected either from the geo browser/geo searchbox or by clicking the Refresh Data button.
  selectedGeo: heatmapData.geo || {}
}

const getters = {
  heatmapState: state => {
    return state.heatmapState
  }
}

const mutations = {
  SET_MAP_BOUNDS (state, options) {
    state.mapBoundsChangedByUser = !!options.mapBoundsChangedByUser
    state.mapBounds = options.mapBounds
  },
  SET_SELECTED_HEATMAP_ID (state, heatmapId) {
    state.selectedHeatmapId = heatmapId
  },
  SET_MAP_INITED (state) {
    state.mapInited = true
  },
  SET_HEATMAP_STATE (state, heatmapState) {
    state.heatmapState = heatmapState
  },
  SET_SELECTED_GEO (state, selectedGeo) {
    state.selectedGeo = selectedGeo
  }
}

const actions = {
  setMapBounds ({commit}, options = {}) {
    commit('SET_MAP_BOUNDS', options)
  },
  setSelectedHeatmapId ({commit}, heatmapId) {
    commit('SET_SELECTED_HEATMAP_ID', heatmapId)
  },
  setMapInited ({commit}) {
    commit('SET_MAP_INITED')
  },
  setHeatmapState ({commit}, heatmapState) {
    commit('SET_HEATMAP_STATE', heatmapState)
  },
  setSelectedGeo ({commit}, geo) {
    commit('SET_SELECTED_GEO', geo)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./frontend/src/store/modules/heatmap/index.js